import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { useSeo } from "../hooks/useSeo";

import Hero from "../components/home/Hero";
import Categories from "../components/home/Categories";
import Positioning from "../components/home/Positioning";
import WhyMako from "../components/home/WhyMako";
import Sports from "../components/home/Sports";
import Compare from "../components/home/Compare";
import Planner from "../components/home/Planner";
import Gallery from "../components/home/Gallery";
import Process from "../components/home/Process";
import BrandStatement from "../components/home/BrandStatement";
import FinalCta from "../components/home/FinalCta";

export default function Home() {
  const { products, settings } = useSite();
  const [installations, setInstallations] = useState([]);

  useSeo({
    title: settings?.seo?.title || "MAKO Mats | Combat Mats and Wall Pads in India",
    description:
      settings?.seo?.description ||
      "Professional puzzle mats, tatami tiles, rollout mats and protective wall padding for MMA, BJJ, wrestling, judo and modern combat facilities.",
  });

  useEffect(() => {
    http.get("/content/installations").then((r) => setInstallations(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <Categories products={products} />
      <Positioning />
      <WhyMako />
      <Sports />
      <Compare products={products} />
      <Planner />
      <Gallery installations={installations} />
      <Process />
      <BrandStatement />
      <FinalCta />
    </div>
  );
}
